<template>
    <div>
        <div :class="(esMovil ? 'row text-center m-auto' : 'd-flex justify-content-between')">
            <div :class="'p-0 mt-3 ' + (esMovil ? 'col-12' : '')">
                <h4>Plazas del recinto</h4>
            </div>
            <div :class="'p-0 ' + (esMovil ? 'col-12' : '')">
                <button :class="'btn btn-primary mb-2 ' + (esMovil ? 'w-100' : '')" @click.prevent="guardarPrecios(plazas)" :disabled="loadingButacas">Guardar todos</button>
            </div>
        </div>
        <hr/>
        <div class="row">
            <div class="col-12">
                <ContentOrLoading>
                    <div v-if="tipos && tipos.length > 0 && plazas">
                        <div v-for="(plaza, index) in originalPlazas" class="row mb-4" :key="index">
                            <div class="col-12 col-md-10">
                                <div class="row">
                                    <div class="col-12 col-md-2 mt-2 mb-2 mb-md-0">
                                        <span class="" v-if="plaza.butaca">
                                            <small>Sector: {{ plaza.sector_name }} - Fila: {{ plaza.fila }}</small><br/>
                                            <strong>Butaca: {{ plaza.butaca }}</strong>
                                        </span>
                                        <strong v-else>{{ plaza.name }}</strong>
                                    </div>
                                    <div class="col-12 col-md-5 mb-2 mb-md-0" :id="'taquilla-' + plaza.id">
                                        <multiselect
                                            v-model="plaza.precios_taquilla"
                                            placeholder="Precios taquilla"
                                            track-by="id"
                                            :custom-label="customLabel"
                                            :options="tipos"
                                            :multiple="true"
                                            :max-height="150"
                                            @select="selected(plaza, 'taquilla')"
                                            @remove="selected(plaza, 'taquilla')"
                                        />
                                    </div>
                                    <div class="col-12 col-md-5" :id="'online-' + plaza.id">
                                        <multiselect
                                            v-model="plaza.precios_online"
                                            placeholder="Precios online"
                                            track-by="id"
                                            :custom-label="customLabel"
                                            :options="tipos"
                                            :multiple="true"
                                            :max-height="150"
                                            @select="selected(plaza, 'online')"
                                            @remove="selected(plaza, 'online')"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-2 text-right mt-2 mt-md-0">
                                <Button 
                                    @click.prevent="guardarPrecios([plaza])" 
                                    :id="'btn-' + plaza.id"
                                    class="btn btn-block"
                                    :disabled="loadingButacas"
                                >
                                    Guardar
                                </Button>
                            </div>
                        </div>
                    </div>
                </ContentOrLoading>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            plazas: {
                type: Array,
                required: true
            },
            tipos: {
                type: Array,
                required: true
            },
            esMovil: {
                type: Boolean
            },
            seleccionarTodas: {
                type: Boolean,
                required: false
            },
            loadingButacas: {
                type: Boolean,
                required: false
            }
        },
        data() {
            return {
                originalPlazas: null,
                loading: false,
                precioSeleccionado: []
            }
        },
        computed: {
            recinto() {
                return this.$store.getters.getRecinto;
            }
        },
        created() {
            this.originalPlazas = this.plazas;
        },
        methods: {
            customLabel(precio) {
                if(precio.renovacion) {
                    return '(Renovación) - ' + `${precio.descripcion ?? precio.description}`;
                }

                return `${precio.descripcion ?? precio.description}`
            },
            guardarPrecios(butacas) {
                this.loading = true;

                var butacas_formatted = [];
                for (var i in butacas) {
                    var precios_online = []
                    var precios_taquilla = []

                    for (var x in butacas[i].precios_online) {
                        precios_online.push(butacas[i].precios_online[x].id)
                    }

                    for (var z in butacas[i].precios_taquilla) {
                        precios_taquilla.push(butacas[i].precios_taquilla[z].id)
                    }

                    butacas_formatted.push({
                        id: butacas[i].id,
                        precios_online: precios_online,
                        precios_taquilla: precios_taquilla,
                    });
                }

                const params = {
                    filters : {},
                    lista_id: this.$store.getters.getListaId,
                    recinto_id: this.recinto.id,
                    butacas: butacas_formatted
                }

                if (window.location.href.includes('/admin/parcelas')) {
                    this.$emit('guardarPrecios', params);
                    return;
                }

                this.$store.dispatch(this.config.getVuexAlias('back.lista.settings.recinto.butacas.guardar.precios'), params).then(res => {
                    this.$emit('getButacas');
                }).finally(() => this.loading = false);
            },
            selected(plazaSelected, tipo) {
                if (this.seleccionarTodas) {
                    this.preciosSeleccionados = tipo === 'taquilla' ? plazaSelected.precios_taquilla : plazaSelected.precios_online;
                    this.originalPlazas.forEach(plaza => {
                        plaza[tipo === 'taquilla' ? 'precios_taquilla' : 'precios_online'] = [...this.preciosSeleccionados];
                    });
                }
                let foundIndex = this.originalPlazas.findIndex(plaza => plaza.id === plazaSelected.id);
                if (foundIndex !== -1) {
                    this.originalPlazas[foundIndex].changed = true;
                }

                if (this.recargar) {
                    this.$emit('recargar');
                }
            },
            volver() {
                this.originalPlazas = null,
                this.$emit('volver');
            }
        }
    }
</script>
